import { createSelector } from 'reselect';
import { mapWithDefault, toJs } from '../../../utils/dataMapper';

const selectStepOtherTugo = (state) => state.get('stepOtherTugo');

const makeSelectStepOtherTugo = () => createSelector(
  selectStepOtherTugo,
  (stepOtherState) => ({
    // Other SCTI
    whatExpensesAreYouClaimingFor: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      ''
    ),
    repatriationBenefitItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'repatriationBenefitItems']) && stepOtherState.getIn(['form', 'repatriationBenefitItems']).toJS(), ''),
    repatriationItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'repatriationItems']) && stepOtherState.getIn(['form', 'repatriationItems']).toJS(), ''),
    returnHomeBenefitItems: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'returnHomeBenefitItems']) && stepOtherState.getIn(['form', 'returnHomeBenefitItems']).toJS(),
      ''
    ),
  })
);

const makeSelectStepOtherTugoErrors = () =>
  createSelector(selectStepOtherTugo, (state) => state.get('errors'));

export {
  makeSelectStepOtherTugo,
  makeSelectStepOtherTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/selectors.js